import { useShowContext } from 'framework/show';
import { ProcessesProvider } from './shared/ProcessesContext';
import { Box } from '@mui/material';
import WelcomeSection from './shared/WelcomeSection';
import LeavesSection from './leaves/Show/LeavesSection';
import CareerSection from './career/CareerSection';
import ContactsSection from './contacts/ContactsSection';
import FeedbackSection from './feedback/Show/FeedbackSection';
import { isPolishB2BOrCFSEmployee } from 'domain/shared/employee';

export const EmployeePortalContent = () => {
  const { data } = useShowContext();
  const rawEmployee = data?.getData?.();
  const employee = rawEmployee && {
    officeId: rawEmployee.officeId,
    contractType: rawEmployee.contractType,
    businessRegistrationCountry: rawEmployee.businessRegistrationCountry,
  };

  const isFeedbackOnlyPortal = isPolishB2BOrCFSEmployee(employee);

  return (
    <ProcessesProvider>
      <Box className="employee-portal" sx={{ display: 'flex', flex: 1, minWidth: 0, flexDirection: 'column', gap: 2 }}>
        {!isFeedbackOnlyPortal && (
          <>
            <WelcomeSection />
            <LeavesSection />
            <CareerSection />
            <ContactsSection />
          </>
        )}
        <FeedbackSection />
      </Box>
    </ProcessesProvider>
  );
};
